module.exports = __webpack_public_path__ + "static/media/acne.94440df0.svg";